module.exports = __webpack_public_path__ + "img/cable-gray-sentosa.ea4be27e.svg";